import { render } from "./SubscriptionManagementV2.vue?vue&type=template&id=2cb9ef6c&scoped=true"
import script from "./SubscriptionManagementV2.vue?vue&type=script&lang=js"
export * from "./SubscriptionManagementV2.vue?vue&type=script&lang=js"

import "./SubscriptionManagementV2.vue?vue&type=style&index=0&id=2cb9ef6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb9ef6c"]])

export default __exports__